import React from "react";
import Advertisement from "../components/Advertisement/Advertisement";


const AdvertisementContainer = () => {
  return (
    <Advertisement />
  );
};

export default AdvertisementContainer;
